import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useContext, useMemo } from 'react';
import { DialogContext } from '../context/provider';
var uuid = 0;
export default function useDialog(Dialog) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var modalId = useMemo(function () {
    return uuid++;
  }, []);

  var _useContext = useContext(DialogContext),
      addDialog = _useContext.addDialog,
      updateDialog = _useContext.updateDialog;

  useEffect(function () {
    addDialog(modalId, {
      open: false,
      props: props,
      Dialog: Dialog
    });
  }, // eslint-disable-next-line
  [modalId]);

  function open() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    updateDialog(modalId, {
      open: true,
      props: _objectSpread(_objectSpread({}, props), p)
    });
  }

  function update() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    updateDialog(modalId, {
      props: _objectSpread(_objectSpread({}, props), p)
    });
  }

  function close() {
    updateDialog(modalId, {
      open: false
    });
  } // eslint-disable-next-line


  var value = useMemo(function () {
    return {
      open: open,
      update: update,
      close: close
    };
  }, []);
  return value;
}